import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import DashboardRootPage from '@/pages/dashboard/DashboardRootPage.vue'
import TransformersRootPage from '@/pages/transformers/TransformersRootPage.vue'
import TransformersPortfolioOverviewPage from '@/pages/transformers/portfolio-overview/TransformersPortfolioOverviewPage.vue'
import TransformersConditionStatusPage from '@/pages/transformers/condition-status/ConditionStatusPage.vue'
import GeneratorsConditionStatusPage from '@/pages/generators/condition-status/ConditionStatusPage.vue'
import RecommendationsPage from '@/pages/recommendations/RecommendationsPage.vue'
import PortfolioTrendsPage from '@/pages/transformers/portfolio-trends/PortfolioTrendsPage.vue'
import ReportsPage from '@/pages/reports/view-all-reports-page/ReportsPage.vue'
import AdminRootPage from '@/pages/admin/AdminRootPage.vue'
import ViewReportPage from '@/pages/reports/view-report-page/ViewReportPage.vue'
import RecommendationTypesPage from '@/pages/admin/recommendation-types/RecommendationTypesPage.vue'
import ExportConditionStatusPage from '@/pages/exports/transformers/condition-status/ExportConditionStatusPage.vue'
import ExportViewReportPage from '@/pages/exports/reports/view-report/ExportViewReportPage.vue'
import GeneratorsPage from '@/pages/generators/GeneratorsPage.vue'
import TurbinesPage from '@/pages/turbines/TurbinesPage.vue'
import ThresholdsPage from '@/pages/admin/thresholds/ThresholdsPage.vue'
import ExportGeneratorsConditionStatusPage from '@/pages/exports/generators/condition-status/ExportConditionStatusPage.vue'
import GeneratorsPortfolioOverviewPage from '@/pages/generators/portfolio-overview/GeneratorsPortfolioOverviewPage.vue'
import GeneratorsPortfolioTrendsPage from '@/pages/generators/portfolio-trends/PortfolioTrendsPage.vue'
import { RouteName } from '@/configuration/route/route-names'
import ReportImagesPage from '@/pages/generators/report-images/ReportImagesPage.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'Index',
        redirect: {
            name: 'Transformers_PortfolioOverview',
        },
    },
    {
        path: '/dashboard',
        name: 'DashboardRoot',
        component: DashboardRootPage,
    },
    {
        path: '/transformers',
        name: 'TransformersRoot',
        component: TransformersRootPage,
        children: [
            {
                path: '',
                name: 'Transformers_Default',
                redirect: {
                    name: 'Transformers_PortfolioOverview',
                },
            },
            {
                path: 'portfolio-overview',
                name: 'Transformers_PortfolioOverview',
                component: TransformersPortfolioOverviewPage,
            },
            {
                path: 'condition-status/:transformerId?',
                name: 'Transformers_ConditionStatus',
                component: TransformersConditionStatusPage,
                props: true,
            },
            {
                path: 'condition-report/:componentSid/:componentType/:reportNumber/:reportType',
                name: 'Transformers_Reports_View_Condition',
                component: ViewReportPage,
                props: true,
            },
            {
                path: 'portfolio-trends',
                name: 'Transformers_PortfolioTrends',
                component: PortfolioTrendsPage,
            },
        ],
    },
    {
        path: '/generators',
        name: 'GeneratorsPage',
        component: GeneratorsPage,
        children: [
            {
                path: '',
                name: 'Generators_Default',
                redirect: {
                    name: 'Generators_PortfolioOverview',
                },
            },
            {
                path: 'portfolio-overview',
                name: 'Generators_PortfolioOverview',
                component: GeneratorsPortfolioOverviewPage,
            },
            {
                path: 'condition-status/:generatorId?',
                name: 'Generators_ConditionStatus',
                component: GeneratorsConditionStatusPage,
                props: true,
            },
            {
                path: 'condition-report/:componentSid/:componentType/:reportNumber/:reportType',
                name: RouteName.GeneratorsReportsViewCondition,
                component: ViewReportPage,
                props: true,
            },
            {
                path: 'portfolio-trends',
                name: 'Generators_PortfolioTrends',
                component: GeneratorsPortfolioTrendsPage,
            },
            {
                path: 'condition-status/:componentSid/:reportNumber/:reportType/images',
                name: 'Reports_Images_View',
                component: ReportImagesPage,
                props: true,
            },
        ],
    },
    {
        path: '/turbines',
        name: 'TurbinesPage',
        component: TurbinesPage,
    },
    {
        path: '/recommendations',
        name: 'RecommendationsRoot',
        component: RecommendationsPage,
    },
    {
        path: '/reports',
        name: 'ReportsRoot',
        children: [
            {
                path: '',
                name: 'Reports_ViewAll',
                component: ReportsPage,
            },
            {
                path: 'view/:componentSid/:componentType/:reportNumber/:reportType',
                name: 'Reports_View',
                component: ViewReportPage,
                props: true,
            },
            {
                path: '*',
                redirect: {
                    name: 'Reports_ViewAll',
                },
            },
        ],
    },
    {
        path: '/admin',
        name: 'AdminRoot',
        component: AdminRootPage,
        children: [
            {
                path: '',
                name: 'Admin_Default',
                redirect: {
                    name: 'Admin_Thresholds',
                },
            },
            {
                path: 'thresholds',
                name: 'Admin_Thresholds',
                component: ThresholdsPage,
            },
            {
                path: 'recommendation-types',
                name: 'Admin_RecommendationTypes',
                component: RecommendationTypesPage,
            },
        ],
    },
    {
        path: '/export/condition-status/:transformerId',
        name: 'Export_ConditionStatus',
        component: ExportConditionStatusPage,
        props: true,
    },
    {
        path: '/generators/export/condition-status/:generatorId',
        name: 'Export_Generators_ConditionStatus',
        component: ExportGeneratorsConditionStatusPage,
        props: true,
    },
    {
        path: '/export/view-report/:componentSid/:componentType/:reportNumber/:reportType',
        name: 'Export_ViewReport',
        component: ExportViewReportPage,
        props: true,
    },
]

export const router = createRouter({
    history: createWebHistory(),
    routes,
})
